// components
import { alpha, Tooltip } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

// styles
import { StyledDutyChip, StyledDutyChipBox } from './DutyChipInToolBar.styles';
import theme from 'config/theme';
import { IconContainer } from 'components/shared/Header/Header.styles';
import {
  StyledSignalIcon,
  StyledSignalIconBottomBox,
  StyledSignalIconTopBox
} from './DutyChip.styles';

// types
import { DutyChipProps } from './DutyChip.types';

const DutyChip = ({
  duties,
  isRightPositioned,
  isTableCell,
  disableTooltip = false,
  tooltipContent,
  signals,
  isAbsentToday
}: DutyChipProps) => {
  return (
    <StyledDutyChipBox
      isRightPositioned={isRightPositioned}
      isTableCell={isTableCell}
    >
      {duties.map((chip) => {
        const isColorHex = chip.color?.startsWith('#');
        const dutyColor = chip.color && chip.color;
        const isBlocked = chip?.isBlocked;
        const dutyColorBackground = isBlocked
          ? alpha(theme.palette.error.main, 0.08)
          : isColorHex && chip.color
          ? alpha(chip.color, 0.08)
          : theme.palette.common.white;
        const dutyColorBorder = isBlocked
          ? alpha(theme.palette.error.main, 0.1)
          : isColorHex && chip.color
          ? alpha(chip.color, 0.1)
          : theme.palette.grey[300];

        const blockedChip = isBlocked
          ? {
              icon: (
                <IconContainer
                  iconSize="MEDIUM"
                  iconColor={theme.vars.palette.error.main}
                >
                  <Icon type="ban" color="inherit" />
                </IconContainer>
              ),
              color: theme.vars.palette.error.main,
              dutyColor: 'transparent'
            }
          : undefined;

        return (
          <Tooltip
            title={tooltipContent ? tooltipContent : chip.code}
            key={chip.code}
            arrow
            disableHoverListener={disableTooltip}
          >
            <StyledDutyChip
              label={
                isBlocked ? (
                  blockedChip?.icon
                ) : (
                  <>
                    <StyledSignalIconTopBox>
                      {signals?.map(
                        (signal) =>
                          signal.active &&
                          !signal.alignBottom && (
                            <StyledSignalIcon
                              key={signal.key}
                              type={signal.icon}
                              color="inherit"
                            />
                          )
                      )}
                    </StyledSignalIconTopBox>
                    {chip.code ?? '—'}
                    <StyledSignalIconBottomBox>
                      {signals?.map(
                        (signal) =>
                          signal.active &&
                          signal.alignBottom && (
                            <StyledSignalIcon
                              key={signal.key}
                              type={signal.icon}
                              color="inherit"
                            />
                          )
                      )}
                    </StyledSignalIconBottomBox>
                  </>
                )
              }
              onClick={() => {}}
              dutyColorBackground={dutyColorBackground}
              dutyColorBorder={dutyColorBorder}
              dutyColor={isBlocked ? undefined : dutyColor}
              isRightPositioned={isRightPositioned}
              isTableCell={isTableCell}
              isAbsentToday={isAbsentToday}
              isFromAnotherCostCenter={chip.isFromAnotherCostCenter}
            />
          </Tooltip>
        );
      })}
    </StyledDutyChipBox>
  );
};

export default DutyChip;
